<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="roles"
        row-key="id"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
          <el-form-item label="角色名称">
            <el-input v-model.trim="filter.roleName" placeholder="请输入角色名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <role-edit ref="roleEdit" @save-success="loadData(1)"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import RoleEdit from "./RoleEdit.vue";

  export default {
    name: "RoleList",
    components: {viewTable, RoleEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(254),
          editAuth: this.$auth(255),
          delAuth: this.$auth(256),
        },
        filter: {
          roleName: "",
        },
        columnsProperty: [
          {
            key: "id",
            width: 70,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.roleEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "roles", row.id).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
